var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-file-list"},_vm._l((_vm.fileList),function(file,index){return _c('div',{key:index,staticClass:"download-file-item"},[_c('a',{attrs:{"href":'http://'+_vm.fileServer+'/files/'+file.downloadName}},[_vm._v(_vm._s(file.displayName))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }